import { render, staticRenderFns } from "./AwardEmptyDefaultLayout.vue?vue&type=template&id=bf045f1e&scoped=true"
import script from "./AwardEmptyDefaultLayout.vue?vue&type=script&lang=js"
export * from "./AwardEmptyDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf045f1e",
  null
  
)

export default component.exports